import { render } from "./nuezMongoDB.vue?vue&type=template&id=2f6abcb7"
import script from "./nuezMongoDB.vue?vue&type=script&lang=js"
export * from "./nuezMongoDB.vue?vue&type=script&lang=js"
script.render = render

export default script